/** Sanitise string value from the < > angle brackets in order to prevent user entering them */
const sanitiseValueFromAngleBrackets = (value: string) => String(value.replace(/[<>]/g, ''));
export default sanitiseValueFromAngleBrackets;
export { sanitiseValueFromAngleBrackets };
